import classNames from 'classnames'

import { getSelectDropdownEntityListItenInfoStylesMods } from '../../../Select'
import Text from '../../../Text'

import * as styles from './PhoneSelectDropdownEntityListItemContentInfoText.module.css'

function PhoneSelectDropdownEntityListItemContentInfoText({
  className = styles.PhoneSelectDropdownEntityListItemContentInfoText,
  ref,
  value,
  ...restProps
}) {
  const { label, phoneCode } = value

  const textClassName = getSelectDropdownEntityListItenInfoStylesMods({
    ...restProps,
    className,
    styles,
  })

  return (
    <div className={styles.container} ref={ref}>
      <Text className={classNames(textClassName, styles.label)}>{label}</Text>
      <Text isSecondary className={classNames(textClassName, styles.code)}>
        +{phoneCode}
      </Text>
    </div>
  )
}

export default PhoneSelectDropdownEntityListItemContentInfoText
